export default function NeonCrowLogo({ size = 160, className = "" }: { size?: number; className?: string }) {
  return (
    <div className={`flex justify-center ${className}`}>
      <img 
        src="/neon-crow-logo.png" 
        alt="Neon Crow Games"
        width={size}
        height={size}
        className="drop-shadow-[0_0_12px_rgba(6,182,212,0.8)]"
      />
    </div>
  );
}
